export default __webpack_public_path__ + "static/media/mdfaishal.f8084289.png";